export const BACKGROUND_STATUS_MAP: Record<string, string[]> = {
  Approved: ['clear', 'engaged'],
  Declined: ['pre-adverse action', 'post adverse action'],
  Pending: ['report.created', 'needs review'],
};

export const I9_STATUS_MAP: Record<string, string[]> = {
  Pending: ['pending', 'pending_section2', 'prospect'],
  'In Progress': ['in_progress', 'e-verify_in_progress'],
  'Pending E-Verify': ['pending_e-verify'],
  Completed: ['approved', 'n/a'],
};

export const ONBOARDING_STATUS_OPTIONS = [
  { label: 'In Progress', value: 'onboarding_in_progress' },
  { label: 'Pending SSN', value: 'pending_ssn' },
  { label: 'Pending Payment', value: 'pending_payment_method' },
  { label: 'Pending Tax', value: 'pending_tax_withholding' },
  { label: 'Pending Workplace', value: 'pending_workplace' },
  { label: 'Completed', value: 'onboarding_completed' },
];

export const DEPENDABILITY_OPTIONS = [
  { label: 'High', value: 'high' },
  { label: 'Medium', value: 'medium' },
  { label: 'Low', value: 'low' },
  { label: 'Not Rated', value: 'not_rated' },
];

export const ACCOUNTABILITY_OPTIONS = [
  { label: 'Active', value: 'active' },
  { label: 'Suspended', value: 'suspended' },
];

export const TAX_TYPE_OPTIONS = [
  { label: 'W2', value: 'w2' },
  { label: '1099', value: '1099' },
];

export const STATUS_OPTIONS = [
  { label: 'Enabled', value: 'true' },
  { label: 'Disabled', value: 'false' },
];

export const getBackgroundDisplayLabel = (raw: string | null): string => {
  if (!raw) return 'N/A';
  for (const [label, values] of Object.entries(BACKGROUND_STATUS_MAP)) {
    if (values.includes(raw)) return label;
  }
  return raw;
};

export const getI9DisplayLabel = (raw: string | null): string => {
  if (!raw) return 'N/A';
  for (const [label, values] of Object.entries(I9_STATUS_MAP)) {
    if (values.includes(raw)) return label;
  }
  return raw;
};

export const expandBackgroundFilter = (selected: string[]): string[] =>
  selected.flatMap((label) => BACKGROUND_STATUS_MAP[label] || [label]);

export const expandI9Filter = (selected: string[]): string[] =>
  selected.flatMap((label) => I9_STATUS_MAP[label] || [label]);
